import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-base" }
const _hoisted_2 = {
  id: "header",
  class: "fixed-top hide-Print"
}
const _hoisted_3 = { id: "main" }

import { useRouter } from 'vue-router';
  import { useQuery } from '@vue/apollo-composable';

  // メッセージボックスのインポート
  import MsgBoxInfo from '@/common/MsgBoxInfo.vue';
  import MsgBoxWarning from '@/common/MsgBoxWarning.vue';
  import MsgBoxOkCancel from '@/common/MsgBoxOkCancel.vue';

  // モデルのインポート
  import { get as gqlGet } from '@/models/Maintenance'; // メンテナンスモデル

//#endregion

//#region フレームワークインスタンスの取得

  // ルーターインスタンスを取得
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  
/********************************************************************************
 * メインモジュール
 *
 * @since 2022/08/30
 * @author 松本裕介
 *
 *********************************************************************************/

//#region モジュールのインポート

  // フレームワークのインポート
  const router = useRouter();

//#endregion
  
//#region リアクティブ設定
//#endregion

//#region DBアクセス定義

  // 取得クエリ
  const { onResult, onError } = useQuery(gqlGet, {getMaintenanceId: "vbtms"}, {fetchPolicy: "cache-and-network", notifyOnNetworkStatusChange: true});

//#endregion

//#region ライフサイクルフック定義

  /********************************************************************************
   * DB取得結果フック
   *
   * @since 2024/07/10
   * @author 松本裕介
   * 
   *********************************************************************************/
  onResult((result) => {

    // ロード中の場合は終了
    if(result.loading) return;

    // メンテナンス中の場合
    if(result.data.getMaintenance.isMaintenance == true){

      // メンテナンス画面表示
      router.push({name: "maintenance"});

    }

  });

  /********************************************************************************
   * エラーフック
   *
   * @since 2024/07/10
   * @author 松本裕介
   * 
   *********************************************************************************/
   onError(error => {

    console.log("Maintenance Error:" + error);

  })

//#endregion


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MsgBoxInfo),
    _createVNode(MsgBoxWarning),
    _createVNode(MsgBoxOkCancel),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createVNode(_component_router_view, { name: "header" })
      ]),
      _createElementVNode("main", _hoisted_3, [
        _createVNode(_component_router_view, { name: "main" })
      ])
    ])
  ], 64))
}
}

})